import { z } from 'zod'

// Validate public client config once at boot so a missing or mistyped env var
// fails loudly here instead of as a confusing error deep inside a request.
const schema = z.object({
  VITE_KEYCLOAK_URL: z.url(),
  VITE_KEYCLOAK_REALM: z.string().min(1),
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1),
  VITE_BFF_URL: z.url(),
  VITE_FORMIO_URL: z.url(),
})

export const env = schema.parse(import.meta.env)
